module.exports = __webpack_public_path__ + "static/media/grafismo-header-esquerdo.a23ac586.svg";